<template>
  <a-config-provider
    :locale="zhCN"
    :theme="{ token: { colorPrimary: '#7C3AED', colorPrimaryHover: 'rgba(124, 58, 237, 0.8)' } }"
  >
    <Layout v-if="!isLogin"></Layout>
    <router-view v-else />
  </a-config-provider>
</template>
<script setup lang="ts">
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import Layout from '@/views/layout.vue';
// import { isNewVersion } from './utils/version';

const resizeTimer: any = ref(null);

dayjs.locale('zh-cn');
// document.addEventListener('visibilitychange', () => {
//   if (document.visibilityState === 'visible') {
//     isNewVersion();
//   }
// });

const route = useRoute();
const config = {
  designWidth: 1240, // 设计稿基准宽度（可根据实际需求修改）
  maxRem: 16, // 1rem 最大对应 px 值
  minRem: 9.6, // 1rem 最小对应 px 值
  baseFontSize: 16, // 设计稿默认 1rem = 16px（基准参考）
};

const isLogin = computed(() => {
  return (
    route.name === null ||
    route.name === 'login' ||
    route.name === 'invite' ||
    route.name === '404' ||
    route.name === 'ppt' ||
    route.name === 'videoEditor'
  );
});

onMounted(() => {
  debounceResize();
  window.addEventListener('resize', debounceResize);
});

// 防抖函数
const debounceResize = () => {
  if (resizeTimer.value) {
    clearTimeout(resizeTimer.value);
  }
  resizeTimer.value = setTimeout(handleResizeWithBreakpoint, 100);
};

const handleResizeWithBreakpoint = () => {
  // 获取当前视口宽度（兼容移动端横屏/竖屏）
  const viewportWidth = Math.min(document.documentElement.clientWidth, window.innerWidth || document.body.clientWidth);

  // 计算基础比例（基于设计稿宽度）
  const scale = viewportWidth / config.designWidth;
  // 计算当前rem应对应的值（基础16px * 比例）
  let currentRem = config.baseFontSize * scale;

  // 限制rem范围：最小9.6px，最大16px
  currentRem = Math.max(config.minRem, Math.min(config.maxRem, currentRem));

  // 设置html根元素的font-size（核心：1rem = currentRem px）
  document.documentElement.style.fontSize = `${currentRem}px`;

  document.documentElement.style.setProperty('--current-rem', `${currentRem}px`);
};
</script>
<style lang="scss" scoped></style>
